<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px"><b>系列月销量(套)</b></div>
      <el-select v-model="catalogCompany" style="width: 150px" @change="initMonthData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="catalogYear" style="width: 150px;margin-left: 10px" @change="initMonthData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;margin-top: 10px" id="monthChart"/>

    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px"><b>月销量同比(套)</b></div>
      <el-select v-model="monthContrastCompany" style="width: 150px" @change="initMonthContrastData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="monthContrastCatalog" style="width:150px;margin-left: 10px" @change="initMonthContrastData">
        <el-option v-for="item in catalogList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="monthContrastYear" style="width: 300px;margin-left: 10px" multiple @change="initMonthContrastData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;" id="monthContrastChart"/>

    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px"><b>335合同数：</b></div>
      <el-select v-model="threeThreeFiveCompany" style="width: 150px" @change="initThreeThreeFiveData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="threeThreeFiveYear" style="width: 150px;margin-left: 10px" @change="initThreeThreeFiveData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;" id="threeThreeFiveChart"/>

    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px"><b>SW单合同套数分布</b></div>
      <el-select v-model="singleSetCompany" style="width: 150px" @change="initSingleSetData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="singleSetYear" style="width: 150px;margin-left: 10px" @change="initSingleSetData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;" id="singleSetChart"/>

    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px"><b>大单(≥5套SW)合同</b></div>
      <el-select v-model="bigOrderCompany" style="width: 150px" @change="initBigOrderData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="bigOrderYear" style="width: 300px;margin-left: 10px" multiple @change="initBigOrderData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;" id="bigOrderChart"/>

    <div style="display: flex;margin-left: 10px;margin-top: 10px">
      <div style="width: 300px;font-size: 18px"><b>1拖N合同</b></div>
      <el-select v-model="oneAndMoreCompany" style="width: 150px" @change="initOneAndMoreData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="oneAndMoreYear" style="width: 300px;margin-left: 10px" multiple @change="initOneAndMoreData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 98%;height: 300px;" id="oneAndMoreChart"/>


  </div>

</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";

export default {
  name: "SalesData",

  data(){
    return{
      companyList:[],
      yearList:[],
      catalogList:[],
      catalogCompany:'summaryData',
      catalogYear:'',
      monthContrastCompany:'summaryData',
      monthContrastCatalog:'',
      monthContrastYear:[],
      threeThreeFiveCompany:'summaryData',
      threeThreeFiveYear:'',
      singleSetCompany:'summaryData',
      singleSetYear:'',
      bigOrderCompany:'summaryData',
      bigOrderYear:[],
      oneAndMoreCompany:'summaryData',
      oneAndMoreYear:[],

      monthSeriesData:[],
      monthContrastSeriesData:[],
      threeThreeFiveSeriesData:[],
      singleSetSeriesData:[],
      bigOrderSeriesData:[],
      oneAndMoreSeriesData:[],

    }

  },
  async created() {
    await this.getYearList();
    await this.getCompanyList();
    await this.getCatalogList();

    await this.initMonthData();
    await this.initMonthContrastData();
    await this.initThreeThreeFiveData();
    await this.initSingleSetData();
    await this.initBigOrderData();
    await this.initOneAndMoreData();

  },

  methods:{

    async initMonthData(){
      await this.getMonthData();
      await this.renderEcharts('monthChart');
    },
    async getMonthData(){
      let params = {company:this.catalogCompany,year:this.catalogYear};
      let data = await this.$http('crmBusinessService.getMonthData',params);
      this.monthSeriesData = data;
    },

    async initMonthContrastData(){
      await this.getMonthContrastData();
      await this.renderEcharts('monthContrastChart');
    },
    async getMonthContrastData(){
      let params = {company:this.monthContrastCompany,year:this.monthContrastYear,catalogId:this.monthContrastCatalog};
      let data = await this.$http('crmBusinessService.getMonthContrastData',params);
      this.monthContrastSeriesData = data;
    },

    async initThreeThreeFiveData(){
      await this.getThreeThreeFiveData();
      await this.renderEcharts('threeThreeFiveChart');
    },
    async getThreeThreeFiveData(){
      let params = {company:this.threeThreeFiveCompany,year:this.threeThreeFiveYear};
      let data = await this.$http('crmBusinessService.getThreeThreeFiveData',params);
      this.threeThreeFiveSeriesData = data;
    },

    async initSingleSetData(){
      await this.getSingleSetData();
      await this.renderEcharts('singleSetChart');
    },
    async getSingleSetData(){
      let params = {company:this.singleSetCompany,year:this.singleSetYear};
      let data = await this.$http('crmBusinessService.getSingleSetData',params);
      this.singleSetSeriesData = data;
    },

    async initBigOrderData(){
      await this.getBigOrderData();
      await this.renderEcharts('bigOrderChart');
    },
    async getBigOrderData(){
      let params = {company:this.bigOrderCompany,year:this.bigOrderYear};
      let data = await this.$http('crmBusinessService.getBigOrderData',params);
      this.bigOrderSeriesData = data;
    },

    async initOneAndMoreData(){
      await this.getOneAndMoreData();
      await this.renderEcharts('oneAndMoreChart');
    },
    async getOneAndMoreData(){
      let params = {company:this.oneAndMoreCompany,year:this.oneAndMoreYear};
      let data = await this.$http('crmBusinessService.getOneAndMoreData',params);
      this.oneAndMoreSeriesData = data;
    },



    async getYearList(){
      const now = dayjs();
      this.catalogYear = now.year() + '';
      this.monthContrastYear.push(now.year() + '');
      this.threeThreeFiveYear = now.year() + '';
      this.singleSetYear = now.year() + '';
      this.bigOrderYear.push(now.year() + '');
      this.oneAndMoreYear.push(now.year() + '');
      this.yearList = await this.$http('sysDsService.getYears(10,1)');
    },
    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      data.unshift({value:'summaryData',label:'汇总数据'})
      this.companyList = data;
    },
    async getCatalogList(){
      this.catalogList = await this.$http('crmBusinessService.getProductCategory');
      if(this.catalogList.length>0){
        this.monthContrastCatalog = this.catalogList[0].id;
      }
    },

    renderEcharts(type){
      if(type === 'monthChart'){
        const monthChartDom = document.getElementById('monthChart');
        // 获取现有的 ECharts 实例（如果有）
        let monthChart = echarts.getInstanceByDom(monthChartDom);

        // 如果存在现有的实例，销毁它
        if (monthChart) {
          monthChart.dispose();
        }
        // 初始化新的 ECharts 实例
        monthChart = echarts.init(monthChartDom);
        monthChart.setOption(this.getMonthChartOptions(), true);
      }
      if(type === 'monthContrastChart'){
        const monthContrastChartDom = document.getElementById('monthContrastChart');
        // 获取现有的 ECharts 实例（如果有）
        let monthContrastChart = echarts.getInstanceByDom(monthContrastChartDom);

        // 如果存在现有的实例，销毁它
        if (monthContrastChart) {
          monthContrastChart.dispose();
        }
        // 初始化新的 ECharts 实例
        monthContrastChart = echarts.init(monthContrastChartDom);
        monthContrastChart.setOption(this.getMonthContrastChartOptions(), true);

      }
      if(type === 'threeThreeFiveChart'){
        const threeThreeFiveChartDom = document.getElementById('threeThreeFiveChart');
        // 获取现有的 ECharts 实例（如果有）
        let threeThreeFiveChart = echarts.getInstanceByDom(threeThreeFiveChartDom);

        // 如果存在现有的实例，销毁它
        if (threeThreeFiveChart) {
          threeThreeFiveChart.dispose();
        }
        // 初始化新的 ECharts 实例
        threeThreeFiveChart = echarts.init(threeThreeFiveChartDom);
        threeThreeFiveChart.setOption(this.getThreeThreeFiveChartOptions(), true);

      }
      if(type === 'singleSetChart'){
        const singleSetChartDom = document.getElementById('singleSetChart');
        // 获取现有的 ECharts 实例（如果有）
        let singleSetChart = echarts.getInstanceByDom(singleSetChartDom);

        // 如果存在现有的实例，销毁它
        if (singleSetChart) {
          singleSetChart.dispose();
        }
        // 初始化新的 ECharts 实例
        singleSetChart = echarts.init(singleSetChartDom);
        singleSetChart.setOption(this.getSingleSetChartOptions(), true);

      }
      if(type === 'bigOrderChart'){
        const bigOrderChartDom = document.getElementById('bigOrderChart');
        // 获取现有的 ECharts 实例（如果有）
        let bigOrderChart = echarts.getInstanceByDom(bigOrderChartDom);

        // 如果存在现有的实例，销毁它
        if (bigOrderChart) {
          bigOrderChart.dispose();
        }
        // 初始化新的 ECharts 实例
        bigOrderChart = echarts.init(bigOrderChartDom);
        bigOrderChart.setOption(this.getBigOrderChartOptions(), true);

      }
      if(type === 'oneAndMoreChart'){
        const oneAndMoreChartDom = document.getElementById('oneAndMoreChart');
        // 获取现有的 ECharts 实例（如果有）
        let oneAndMoreChart = echarts.getInstanceByDom(oneAndMoreChartDom);

        // 如果存在现有的实例，销毁它
        if (oneAndMoreChart) {
          oneAndMoreChart.dispose();
        }
        // 初始化新的 ECharts 实例
        oneAndMoreChart = echarts.init(oneAndMoreChartDom);
        oneAndMoreChart.setOption(this.getOneAndMoreChartOptions(), true);

      }


    },
    getMonthChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          confine: true
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.monthSeriesData === undefined ? [] : this.monthSeriesData
      }
    },
    getMonthContrastChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.monthContrastSeriesData === undefined ? [] : this.monthContrastSeriesData
      }
    },
    getThreeThreeFiveChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.threeThreeFiveSeriesData === undefined ? [] : this.threeThreeFiveSeriesData
      }
    },
    getSingleSetChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.singleSetSeriesData === undefined ? [] : this.singleSetSeriesData
      }
    },
    getBigOrderChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.bigOrderSeriesData === undefined ? [] : this.bigOrderSeriesData
      }
    },
    getOneAndMoreChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.oneAndMoreSeriesData === undefined ? [] : this.oneAndMoreSeriesData
      }
    }
  }
}
</script>

<style scoped>

</style>